import * as React from 'react';

const PaginateBack = (props) => (
  <svg
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='36' height='36' fill='#F5F5F5' />
    <g id='Main Page'>
      <rect
        width='1728'
        height='3382'
        transform='translate(-615 -2005)'
        fill='white'
      />
      <circle id='Ellipse 1' cx='18' cy='18' r='18' fill='currentColor' />
      <g id='left-arrow 1'>
        <g id='Group'>
          <g id='Group_2'>
            <path
              id='Vector'
              d='M14.8625 18.5036L21.2221 12.1437C21.3972 11.969 21.4936 11.7354 21.4936 11.4863C21.4936 11.2371 21.3972 11.0037 21.2221 10.8287L20.6649 10.2717C20.49 10.0965 20.2563 10 20.0073 10C19.7582 10 19.5248 10.0965 19.3498 10.2717L11.7776 17.8438C11.6019 18.0193 11.5057 18.2538 11.5064 18.5032C11.5057 18.7536 11.6018 18.9879 11.7776 19.1636L19.3427 26.7283C19.5177 26.9035 19.7512 27 20.0003 27C20.2494 27 20.4828 26.9035 20.658 26.7283L21.2151 26.1713C21.5776 25.8088 21.5776 25.2186 21.2151 24.8562L14.8625 18.5036Z'
              fill='white'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default PaginateBack;
